<template lang="pug">
.content
    .res(:class="`r${res.x}x${res.y}`")
        Vid.vid(ref="vids" :src="vidsrc" :loop="datas[cur].loop" :endCallBack="onPlayEnd" :width="res.x" :height="res.y" :muted="curname!=='A1'" :vidProgress="onProgress") 
        //- .phone(v-show="cur>0")
        //-     video(:src="svidsrc" :loop="false" muted autoplay)
        //- .cover(@click="playSound")
        //-     Audio.bgsound#bgsound(ref='sound' :src='`${bgm.path}`'  type='audio/mpeg' loop autoplay)
        .pbg(v-show="curname==='A1'")
            ProgressBar(ref="pb" @vol="onpb" w=1920 h=10 l=0 t=1050)
        .ui1.abs.l.t(v-show="curname==='0'")
            .bt1.abs.bt.hand(@click="()=>setNam('8')")
            .bt2.abs.bt.hand(@click="()=>setNam('10')")
            .bt3.abs.bt.hand(@click="()=>setNam('12')")
            .bt4.abs.bt.hand(@click="()=>setNam('13')")
            .bt5.abs.bt.hand(@click="()=>openUrl2('https://expcloud.huawei.com/exp/easy/evolution/preview?appCode=0155c4af-c111-4b61-b38e-2fff81ec5e01&hasHeader=1&lang=en-US&version=v1&locale=en-US')")

            .bt6.abs.btm.hand(@click="()=>setNam('1')")
            .bt7.abs.btm.hand(@click="()=>setNam('14')")
        .g1.abs.l.t(v-show="curname==='9'")
            //- .bg.abs
            .img.img1.cont.abs(:style="`backgroundImage:url(${path}imgs/5.png)`" :class="showId===0?'show':''" ref="img1")
            .img.img2.cont.abs(:style="`backgroundImage:url(${path}imgs/3.png)`" :class="showId===1?'show':''" ref="img2")
            .img.img3.cont.abs(:style="`backgroundImage:url(${path}imgs/1.png)`" :class="showId===2?'show':''" ref="img3")
            .img.img6.cont.abs(:style="`backgroundImage:url(${path}imgs/6.png)`" :class="showId===2?'show':''" ref="img6")
            .img.img5.cont.abs(:style="`backgroundImage:url(${path}imgs/4.png)`" :class="showId===1?'show':''" ref="img5")
            .img.img4.cont.abs(:style="`backgroundImage:url(${path}imgs/2.png)`" :class="showId===0?'show':''" ref="img4")
            .bt.bpre.cont.abs.hand(@click="()=>setShowId(showId-1)")
            .bt.bnxt.cont.abs.hand(@click="()=>setShowId(showId+1)")
        .g2.abs.l.t
            .img.img1.cont.abs(:style="`backgroundImage:url(${path}imgs/a1.png)`" v-show="curname==='4'")
            .img.img2.cont.abs(:style="`backgroundImage:url(${path}imgs/b1.png)`" v-show="curname==='4'")
            .img.img1.cont.abs(:style="`backgroundImage:url(${path}imgs/a2.png)`" v-show="curname==='5'")
            .img.img2.cont.abs(:style="`backgroundImage:url(${path}imgs/b2.png)`" v-show="curname==='5'")

        ul.ui
            li(
                v-for="item,id in ui" 
                :key="id" 
                :style="`backgroundImage:url(${item.src});width:${pxToRem(item.w)};height:${pxToRem(item.h)};left:${pxToRem(item.l)};top:${pxToRem(item.t)}`"
                v-show="item.vis.split('_').indexOf(curname)!==-1||item.vis===''"
                @click="()=>handleUI(item.cmd,item.arg)"
                )

        ul.hot
            li(
                v-for="item,id in hots" 
                :key="id" 
                :style="`backgroundColor:red;opacity:${hotAlpha};width:${pxToRem(item.w)};height:${pxToRem(item.h)};left:${pxToRem(item.l)};top:${pxToRem(item.t)};`"
                v-show="item.vis.split('_').indexOf(curname)!==-1||item.vis===''"
                @click="()=>handleHot(item.cmd,item.arg)"
                )
        HotPP(
            v-for="item,id in uipp" 
            :key="id"
            :bgsrc="item.src1"
            :bgsrc2="item.src2"
            :w="item.w"
            :h="item.h"
            :l="item.l"
            :t="item.t"
            :func="()=>handleUIPP(item.cmd,item.arg,id)"
            :ref="`hotpp${id}`"
            v-show="item.vis.split('_').indexOf(curname)!==-1||item.vis===''"
            )
        Pop.pop(
            ref='pop'
            w=960
            h=540
            :src="`${path}${lang}${popnam}.mp4`"
        )
        Breath(l=1782 t=542 v-show="curname==='12'")
        Breath(l=3466 t=542 v-show="curname==='12'")
            .back(@click='onback()')
        iframe.fram.w100.h100.abs.l.t#fram(:src="iurl" v-show="iurl!==''")
        .framback.abs.cont.hand#frameback(style="backgroundImage:url('./static/icon/deepback.png')" v-show="iurl!==''" @click="onframback")
        Info(:w="res.x" :h="res.y" v-if="debug")
        //- img.img1(:src="`${path}${lang}s1.svg`")
        //- object(id="object" :data="`${path}${lang}s1.svg`" type="image/svg+xml" style="position:absolute;top:0px;")
        //- iframe(id="iframe" :src="`${path}${lang}s1.svg`")
        .gtime(v-show="curname==='A1'")
            span {{ctime}}/{{ttime}}
        
        .Debug(v-if="debug") {{cur}} {{lang}} {{vidsrc}}
            h4 {{showId}}

</template>
<script>
//import axios from 'axios'
import FontService from '@/services/FontService'
import KeyService from '@/services/KeyService'
import SocketService from '@/services/SocketService'
import { mapMutations, mapState } from 'vuex'
import ResizeService from '@/services/ResizeService'
import Vid from '@/components/common/VidSimple4'
import HotPP from '@/components/common/HotPP'
import Breath from '@/components/common/Breath'
import Pop from '@/components/common/Pop'
import ProgressBar from '@/components/common/ProgressBar2'
import Info from '@/components/common/Info'
import basefunc from '@/components/common/basefunc'
import gsap from 'gsap'
const configdata={
    "debug":false,
    "path":"./static/A/A2/",
    "isc3":false,
    "isofficial":false,
    "startLan":"cn",
    "res":{"x":3840,"y":2160},
    "datas":[
        {"name":"0","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"1","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"2","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"3","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"4","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"5","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"6","type":"mp4","loop":true,"next":"","key":"a"},
            {"name":"7","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"8","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"9","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"10","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"11","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"12","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"13","type":"mp4","loop":true,"next":"","key":"a"},
        {"name":"14","type":"mp4","loop":true,"next":"","key":"a"}

    ],
    "hotAlpha":0,
    "hots":[

        {"cmd":"hot","arg":"2","vis":"3_4_5","l":214,"t":327,"w":348,"h":348},
        {"cmd":"hot","arg":"3","vis":"2_4_5","l":214,"t":951,"w":348,"h":348},
        {"cmd":"hot","arg":"4","vis":"2_3","l":214,"t":1548,"w":348,"h":348},

        {"cmd":"hot","arg":"5","vis":"4","l":2278,"t":1924,"w":653,"h":167},
        {"cmd":"hot","arg":"4","vis":"5","l":1561,"t":1924,"w":653,"h":167},

        {"cmd":"hot","arg":"9","vis":"8","l":3346,"t":1113,"w":158,"h":214},
        {"cmd":"hot","arg":"8","vis":"9","l":3346,"t":1113,"w":158,"h":214},
        {"cmd":"hot1","arg":"9","vis":"8","l":1705,"t":758,"w":1595,"h":892},
        {"cmd":"hot","arg":"8","vis":"9","l":327,"t":1113,"w":158,"h":214},
        {"cmd":"hot","arg":"9","vis":"8","l":327,"t":1113,"w":158,"h":214},

        {"cmd":"hot","arg":"11","vis":"10","l":1256,"t":711,"w":348,"h":214},

        {"cmd":"hot2","arg":"14","vis":"12","l":335,"t":538,"w":1448,"h":718},
        {"cmd":"hot3","arg":"14","vis":"12","l":2021,"t":538,"w":1448,"h":718}

    ],
    "ui":[
        {"src":"./static/icon/deepnext.png","cmd":"back","arg":"6","vis":"1","l":3640,"t":2060,"w":80,"h":80},
        {"src":"./static/icon/deepnext.png","cmd":"back","arg":"2","vis":"6","l":3640,"t":2060,"w":80,"h":80},
        {"src":"./static/icon/deepprev.png","cmd":"back","arg":"1","vis":"6","l":3540,"t":2060,"w":80,"h":80},
        {"src":"./static/icon/deepprev.png","cmd":"back","arg":"6","vis":"2_3_4_5","l":3540,"t":2060,"w":80,"h":80},
        {"src":"./static/icon/deepback.png","cmd":"back","arg":"10","vis":"11","l":3640,"t":2060,"w":80,"h":80},
        {"src":"./static/icon/deephome.png","cmd":"home","arg":"","vis":"1_2_3_4_5_6_7_8_9_10_11_12_13_14","l":3740,"t":2060,"w":80,"h":80},
        {"src":"./static/icon/deepclose.png","cmd":"sock","arg":"exit","vis":"-1","l":6070,"t":30,"w":80,"h":80}

    ],
    "uipp":[
        {"src1":"./static/icon/deepcn.png","src2":"./static/icon/deepen.png","cmd":"lang","arg":"cn|en","vis":"-1","l":3740,"t":2060,"w":100,"h":100},
        {"src1":"./static/icon/deeppause.png","src2":"./static/icon/deepresume.png","cmd":"vctl","arg":"","vis":"A1","l":1790,"t":1660,"w":100,"h":100}
    ],

    "bgm":{
        "path":"","volume":0.5
    }
    
}
export default {
    data(){
        return{
            //2,3,4,5,13,10,11,12,n11,n12,7,v14,v15,v16,v17,8,n19,n20,n21,17,n23,15,n25,n26,n27,n28
            debug: configdata.debug,
            hotAlpha: configdata.hotAlpha,
            path: configdata.path,
            bgm: configdata.bgm,
            res: configdata.res,
            datas: configdata.datas,
            ui: configdata.ui,
            hots: configdata.hots,
            uipp: configdata.uipp,
            isOfficial: configdata.isofficial,

            popnam: '',
            ctime: '00:00',
            ttime: '01:00',
            showId: 0,
            iurl: '',
        }
    },
    mixins: [basefunc],
    computed:{
        vidsrc(){
            return this.path+this.lang+this.datas[this.cur].name+'.'+this.datas[this.cur].type
        },
        svidsrc(){//官网版需把视频放到obs,并删掉public多余的视频
            if(!this.isOfficial)
                return this.path+this.lang+'s'+this.datas[this.cur].name+'.'+this.datas[this.cur].type
            else
                return 'https://panstone-share.obs.cn-south-1.myhuaweicloud.com/xw/JZone/ph2/'+'s'+this.datas[this.cur].name+'.'+this.datas[this.cur].type

        },
        curname(){
            return this.datas[this.cur].name
        },

        ...mapState('app',['cur','lang','jqarg'])
    },
    watch:{
        curname(val){
            if(val==='9')this.showId=0
        }
    },
    components:{
        Vid,
        HotPP,
        Pop,
        Breath,
        ProgressBar,
        Info,
    },
    mounted(){
        // load config
        /*axios.get(config).then(response=>{
            const result = response.data
            //this.something = data
            this.assets = result.assets
        })*/
        // set up resize service and keyservice
        FontService.getInstance()
        //KeyService.getInstance().add('c', this.showControl)
        KeyService.getInstance().updateF(this.$el)
        ResizeService.getInstance().updateDirection(`r${this.res.x}x${this.res.y}`)
        this.initDatas()

        KeyService.getInstance().add('space',this.simpp)
        KeyService.getInstance().add('down',this.simnext)
        KeyService.getInstance().add('up',this.simprev)
        KeyService.getInstance().add('esc',this.handleUI.bind(this,'sock','exit'))
        // this.$refs.sound.volume=Number(this.bgm.volume)

        // setInterval(() => {
        //     this.setShowId(this.showId+1)
        // }, 3000)

        // this.lunbo()
    },
    methods:{
        //showControl(){
            //console.log('add your control here like following')
            //window.open('/#/D1_3_Control','_blank')
        //},
        initDatas(){
            let s=''
            this.datas.map(item=>s+=item.name+'_')
            console.log(s)
            //三朵云需取消这里
            if(!configdata.isc3){
                this.setLang(configdata.startLan) 
                this.$refs['hotpp0'][0].setSelected(true)
            }
        },
        
        onPlayEnd(){
            if(this.datas[this.cur].next!=="")this.setNam(this.datas[this.cur].next)
        },
        setNam(nam){
            let c=-1
            this.datas.map((item,id)=>{
                if(item.name===nam) c=id
            })
            if(c!==-1){
                this.dealCur(c)
            }
        },
        dealCur(n){
            if(n>=0&&n<this.datas.length)this.setCur(n)
        },
        handleUI(cmd,arg){
            console.log(cmd,arg)
            if(cmd==='home') this.dealCur(0)
            else if(cmd==='prev') this.dealCur(this.cur-1)
            else if(cmd==='next') this.dealCur(this.cur+1)
            else if(cmd==='back') this.setNam(arg)
            else if(cmd==='sock'&&arg==='exit') {window.opener=null;window.close()}
            else if(cmd==='sock')SocketService.getInstance().emit('j',{val:arg}) 
            
        },
        handleHot(cmd,arg){
            console.log(cmd,arg)
            if(cmd==='hot')this.setNam(arg)
            else if(cmd==='pop') {
                this.$refs.pop.showPop(true)
                this.popnam=arg
            }else if(cmd==='sock')SocketService.getInstance().emit('j',{val:arg})
            else if(cmd==='hot1')this.openUrl2(`${this.path}html/final/pages/tables/taxpayerBlank.html`)
            else if(cmd==='hot2')this.openUrl2(`${this.path}demo2/index.html`)
            else if(cmd==='hot3')this.openUrl2(`${this.path}demo1/index.html`)
        },
        onback(){
            this.$refs.pop.showPop(false)
        },
        handleUIPP(cmd,arg,id){
            console.log(cmd,arg)
            // console.log(this.$refs['hotpp'+id][0].getSelected())
            const args=arg.split('|')
            if(cmd==='lang'&&args.length>=2) this.setLang(this.$refs['hotpp'+id][0].getSelected()?args[1]:args[0])
            else if(cmd==='vctl') {
                if(!this.$refs['hotpp'+id][0].getSelected())this.$refs['vids'].pause()
                else this.$refs['vids'].resume()
            }
            
        },
        simpp(){
            if(!this.$refs['hotpp1'][0].getSelected()){
                this.$refs['vids'].pause()
                this.$refs['hotpp1'][0].setSelected(true)
            }else {
                this.$refs['vids'].resume()
                this.$refs['hotpp1'][0].setSelected(false)
            }
        },
        simnext(){
            if('1_3_4_5_12_14_15_17_22_24_26_28_30'.split('_').indexOf(this.curname)!==-1)this.dealCur(this.cur+1)
        },
        simprev(){
            if('3_4_5_9_14_15_17_19_24_26_28_30_32'.split('_').indexOf(this.curname)!==-1)this.dealCur(this.cur-1)
        },
        playSound(){
            this.$refs['sound'].play()
        },
        onpb(v){
            console.log('onpb:',v.val)
            this.$refs['vids'].seekfactor(v.val*0.01)
            this.$refs['pb'].setVal(v.val)
            this.$refs['pb'].setSeeking(false)
        },
        onProgress(v){
            // console.log(v)
            if(v)this.$refs['pb'].setVal(v*100)
            this.ctime=this.timeFormat(this.$refs['vids'].currentTime())
            this.ttime=this.timeFormat(this.$refs['vids'].duration())
        },
        openUrl(url){
            window.open(url,'_blank')
        },
        openUrl2(url){
            this.iurl=url
        },
        setShowId(n){
            if(n>=3)n=0
            if(n<0)n=2
            this.showId=n
            this.lunbo2()
        },
        onframback(){
            this.iurl=''
        },
        lunbo(){
            const times=-1
            const yanchi=3
            const t1=gsap.timeline({repeat:times,repeatDelay:1})
            t1.set(this.$refs.img1,{scale:.7,zIndex:100})
            t1.to(this.$refs.img1,{x:this.pxToRem(200),scale:.85,opacity:.7,duration:1,delay:yanchi})
            t1.set(this.$refs.img1,{zIndex:101})
            t1.to(this.$refs.img1,{x:this.pxToRem(400),scale:1,opacity:1,duration:1,delay:yanchi})
            t1.set(this.$refs.img1,{zIndex:102})
            t1.to(this.$refs.img1,{x:0,scale:0.7,opacity:.4,duration:1,delay:yanchi})

            const t2=gsap.timeline({repeat:times,repeatDelay:1})
            t2.set(this.$refs.img2,{scale:.85,zIndex:101})
            t2.to(this.$refs.img2,{x:this.pxToRem(200),scale:1,opacity:1,duration:1,delay:yanchi})
            t2.set(this.$refs.img2,{zIndex:102})
            t2.to(this.$refs.img2,{x:this.pxToRem(-200),scale:0.7,opacity:.4,duration:1,delay:yanchi})
            t2.set(this.$refs.img2,{zIndex:100})
            t2.to(this.$refs.img2,{x:this.pxToRem(0),scale:0.85,opacity:.7,duration:1,delay:yanchi})

            const t3=gsap.timeline({repeat:times,repeatDelay:1})
            t3.set(this.$refs.img3,{scale:1,zIndex:102})
            t3.to(this.$refs.img3,{x:this.pxToRem(-400),scale:0.7,opacity:.4,duration:1,delay:yanchi})
            t3.set(this.$refs.img3,{zIndex:100})
            t3.to(this.$refs.img3,{x:this.pxToRem(-200),scale:0.85,opacity:.7,duration:1,delay:yanchi})
            t3.set(this.$refs.img3,{zIndex:101})
            t3.to(this.$refs.img3,{x:this.pxToRem(0),scale:1,opacity:1,duration:1,delay:yanchi})

            const t6=gsap.timeline({repeat:times,repeatDelay:1})
            t6.set(this.$refs.img6,{scale:.7,zIndex:103})
            t6.to(this.$refs.img6,{x:this.pxToRem(-200),scale:.85,opacity:.7,duration:1,delay:yanchi})
            t6.set(this.$refs.img6,{zIndex:104})
            t6.to(this.$refs.img6,{x:this.pxToRem(-400),scale:1,opacity:1,duration:1,delay:yanchi})
            t6.set(this.$refs.img6,{zIndex:105})
            t6.to(this.$refs.img6,{x:0,scale:0.7,opacity:.4,duration:1,delay:yanchi})

            const t5=gsap.timeline({repeat:times,repeatDelay:1})
            t5.set(this.$refs.img5,{scale:.85,zIndex:104})
            t5.to(this.$refs.img5,{x:this.pxToRem(-200),scale:1,opacity:1,duration:1,delay:yanchi})
            t5.set(this.$refs.img5,{zIndex:105})
            t5.to(this.$refs.img5,{x:this.pxToRem(200),scale:0.7,opacity:.4,duration:1,delay:yanchi})
            t5.set(this.$refs.img5,{zIndex:103})
            t5.to(this.$refs.img5,{x:this.pxToRem(0),scale:0.85,opacity:.7,duration:1,delay:yanchi})

            const t4=gsap.timeline({repeat:times,repeatDelay:1})
            t4.set(this.$refs.img4,{scale:1,zIndex:105})
            t4.to(this.$refs.img4,{x:this.pxToRem(400),scale:0.7,opacity:.4,duration:1,delay:yanchi})
            t4.set(this.$refs.img4,{zIndex:103})
            t4.to(this.$refs.img4,{x:this.pxToRem(200),scale:0.85,opacity:.7,duration:1,delay:yanchi})
            t4.set(this.$refs.img4,{zIndex:104})
            t4.to(this.$refs.img4,{x:this.pxToRem(0),scale:1,opacity:1,duration:1,delay:yanchi})
        },
        lunbo2(){
            const yanchi=1
            const dur=.5
            if(this.showId===1){
                gsap.to(this.$refs.img1,{x:this.pxToRem(200),scale:.85,opacity:.7,duration:dur})
                gsap.set(this.$refs.img1,{zIndex:101,delay:yanchi})
            }else if(this.showId===2){
                gsap.to(this.$refs.img1,{x:this.pxToRem(400),scale:1,opacity:1,duration:dur})
                gsap.set(this.$refs.img1,{zIndex:102,delay:yanchi})
            }else if(this.showId===0){
                gsap.to(this.$refs.img1,{x:0,scale:0.7,opacity:.4,duration:dur})
                gsap.set(this.$refs.img1,{scale:.7,zIndex:100,delay:yanchi})
            }

            if(this.showId===1){
                gsap.to(this.$refs.img2,{x:this.pxToRem(200),scale:1,opacity:1,duration:dur})
                gsap.set(this.$refs.img2,{zIndex:102,delay:yanchi})
            }else if(this.showId===2){
                gsap.to(this.$refs.img2,{x:this.pxToRem(-200),scale:0.7,opacity:.4,duration:dur})
                gsap.set(this.$refs.img2,{zIndex:100,delay:yanchi})
            }else if(this.showId===0){
                gsap.to(this.$refs.img2,{x:this.pxToRem(0),scale:0.85,opacity:.7,duration:dur})
                gsap.set(this.$refs.img2,{scale:.85,zIndex:101,delay:yanchi})
            }

            if(this.showId===1){
                gsap.to(this.$refs.img3,{x:this.pxToRem(-400),scale:0.7,opacity:.4,duration:dur})
                gsap.set(this.$refs.img3,{zIndex:100,delay:yanchi})
            }else if(this.showId===2){
                gsap.to(this.$refs.img3,{x:this.pxToRem(-200),scale:0.85,opacity:.7,duration:dur})
                gsap.set(this.$refs.img3,{zIndex:101,delay:yanchi})
            }else if(this.showId===0){
                gsap.to(this.$refs.img3,{x:this.pxToRem(0),scale:1,opacity:1,duration:dur})
                gsap.set(this.$refs.img3,{scale:1,zIndex:102,delay:yanchi})
            }

            if(this.showId===1){
                gsap.to(this.$refs.img6,{x:this.pxToRem(-200),scale:.85,opacity:.7,duration:dur})
                gsap.set(this.$refs.img6,{zIndex:104,delay:yanchi})
            }else if(this.showId===2){
                gsap.to(this.$refs.img6,{x:this.pxToRem(-400),scale:1,opacity:1,duration:dur})
                gsap.set(this.$refs.img6,{zIndex:105,delay:yanchi})
            }else if(this.showId===0){
                gsap.to(this.$refs.img6,{x:0,scale:0.7,opacity:.4,duration:dur})
                gsap.set(this.$refs.img6,{scale:.7,zIndex:103,delay:yanchi})
            }

            if(this.showId===1){
                gsap.to(this.$refs.img5,{x:this.pxToRem(-200),scale:1,opacity:1,duration:dur})
                gsap.set(this.$refs.img5,{zIndex:105,delay:yanchi})
            }else if(this.showId===2){
                gsap.to(this.$refs.img5,{x:this.pxToRem(200),scale:0.7,opacity:.4,duration:dur})
                gsap.set(this.$refs.img5,{zIndex:103,delay:yanchi})
            }else if(this.showId===0){
                gsap.to(this.$refs.img5,{x:this.pxToRem(0),scale:0.85,opacity:.7,duration:dur})
                gsap.set(this.$refs.img5,{scale:.85,zIndex:104,delay:yanchi})
            }

            if(this.showId===1){
                gsap.to(this.$refs.img4,{x:this.pxToRem(400),scale:0.7,opacity:.4,duration:dur})
                gsap.set(this.$refs.img4,{zIndex:103,delay:yanchi})
            }else if(this.showId===2){
                gsap.to(this.$refs.img4,{x:this.pxToRem(200),scale:0.85,opacity:.7,duration:dur})
                gsap.set(this.$refs.img4,{zIndex:104,delay:yanchi})
            }else if(this.showId===0){
                gsap.to(this.$refs.img4,{x:this.pxToRem(0),scale:1,opacity:1,duration:dur})
                gsap.set(this.$refs.img4,{scale:1,zIndex:105,delay:yanchi})
            }
        },
        ...mapMutations('app',['setLang','setCur'])
    }

}
</script>

<style lang="sass" scoped>
@import '@/styles/common'
@import '@/styles/edge'
.content
    +full()
    display: flex
    justify-content: center
    align-items: center
    overflow: hidden
    .res
        background: #ddd
        .cover
            +full()
        .phone
            position: absolute
            +size(416,898)
            +pos(834,97)
            // background: #f00
            overflow: hidden
            border-radius: pxToRem(56)
            video
                object-fit: contain
                +size(416,898)

        .ui,.hot
            position: absolute
            top: 0
            left: 0
            li
                +contain()
                cursor: pointer
        
        .pop
            .back
                position: absolute
                background: #f006
                +size(100,100)
                +pos(0,0) 
                cursor: pointer   
        .gtime
            position: absolute
            +size(100,40)
            color: #000
            +pos(1600,1010)
            line-height: pxToRem(40)

        .ui1
            .bt
                +size(408,180)
                transform: skewY(30deg)
                transform-origin: left top
                &.bt1
                    +pos(736,436)
                &.bt2
                    +size(508,280)
                    +pos(1572,677)
                &.bt3
                    +pos(2557,476)
                &.bt4
                    +pos(2994,842)
                &.bt5
                    +pos(3214,1239)
            .btm
                +size(568,140)
                // background: #006fff
                font-size: pxToRem(60)
                line-height: pxToRem(140)
                text-align: center
                transition: all .5s
                &.bt6
                    +pos(1022,1938)
                &.bt7
                    +pos(2272,1938)
                &:hover
                    opacity: .8
                    color: aqua
.g1
    +pos(1711,772)
    .bg
        +size(3294-1711,1647-772)
        background-color: rgb(13,98,133)
    .img
        // +pos(2159-1711,808-772)
        +size(332,796)
        transition: all 1s
        &.img1
            opacity: 0.4
            +pos(2159-1711-400,808-772)
            transform: scale(.7)
        &.img2
            opacity: 0.7
            +pos(2159-1711-200,808-772)
            transform: scale(.85)
        &.img3
            opacity: 1
            +pos(2159-1711,808-772)
        &.img4
            opacity: 1
            +pos(2159-1711+332,808-772)
        &.img5
            opacity: 0.7
            +pos(2159-1711+332+200,808-772)
            transform: scale(.85)
        &.img6
            opacity: 0.4
            +pos(2159-1711+332+400,808-772)
            transform: scale(.7)
    .show
        opacity: 1
    .bt
        +size(134,211)
        &.bpre
            +pos(0,300)
        &.bnxt
            +pos(3294-1711-134,300)
.g2
    .img
        +size(653,167)
    .img1
        +pos(1558,1924)
    .img2
        +pos(2280,1924)
.framback
    +size(80,80)
    +pos(3740,2060)
</style>